module.exports = __webpack_public_path__ + "static/media/success.2d2268b8.png";